export default "__VITE_ASSET__60e7acd4__"